//export default function publicKey(state = { publicKey: (localStorage.getItem("public") ? JSON.parse(localStorage.getItem("public")) : ""), keyRecieved: false }, action) {
export default function publicKey(state = { publicKey: JSON.parse(localStorage.getItem("public") ), keyRecieved: false }, action) {
switch (action.type) {
        case 'PUBLIC_KEY':
            return {
                publicKey: action.publicKey,
                keyRecieved: action.keyRecieved
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer/publickey.jsx